<template>
  <div
    id="editCommentModal"
    aria-labelledby="editCommentModalLabel"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            ref="close"
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
            @click="onResetForm"
          >
            <span
              aria-hidden="true"
            >&times;</span>
          </button>
          <h4
            id="editCommentModalLabel"
            class="modal-title"
          >
            {{ $t('string.editComment') }}
          </h4>
        </div>
        <div class="modal-body">
          <div>
            <x-textarea
              v-model="comment"
              :label="$t('string.comment')"
              :placeholder="$t('placeholder.comment')"
              :required="true"
              :rows="5"
              :validations="validations"
              name="comment"
            />
          </div>

          <div
            :class="{'has-error' : validations['files']}"
            class="form-group"
          >
            <label for="files">
              <input
                id="files"
                ref="files"
                accept="image/png,image/jpeg,image/jpg,.doc,.docx,.pdf"
                multiple
                type="file"
              >
              <template v-if="validations['files']">
                <span class="help-block">{{ validations['files'][0] }}</span>
              </template>
            </label>
          </div>

          <div
            v-if="Array.isArray(files) && files.length"
            class="from-group"
          >
            <label for="existedFiles">{{ $t('string.existedFiles') }}</label>
            <ul id="existedFiles">
              <li
                v-for="(file, key) in files"
                :key="key"
              >
                <a
                  :href="`${$base_api}/${file.src}`"
                  target="_blank"
                >
                  {{ file.filename || 'N/A' }}
                  <template v-if="can([$Permissions.backend.comment.deleteFilesComment])">
                    -
                    <span
                      class="text-red"
                      @click="onDeleteFile($event, file)"
                    >{{ $t('button.delete') }}</span>
                  </template>
                </a>
              </li>
            </ul>
          </div>
          <div class="form-group">
            <button
              class="btn btn-success btn-sm margin-right-5"
              type="button"
              @click="onSave"
            >
              {{ $t('button.update') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'EditCommentModal',
  data () {
    return {
      validations: {},
      comment: '',
      isLoading: false,
      files: [],
      isSaveWaiting: false
    }
  },
  computed: {
    ...mapState({
      comment_uuid: state => state.comment.comment_uuid,
      toggle_edit_comment_modal: state => state.comment.toggle_edit_comment_modal
    })
  },
  watch: {
    toggle_edit_comment_modal () {
      if (this.comment_uuid) {
        this.getComment()
      }
    }
  },
  methods: {
    onDeleteFile (e, file) {
      e.preventDefault()
      this.onConfirm().then((accept) => {
        if (accept) {
          this.$isLoading(true)
          this.$axios.post(this.$base_api + '/api/v4/backend/comment/delete-file', {
            file_uuid: file.uuid
          }).then(() => {
            this.$store.commit('comment/setRefreshCommentList')
            this.onDeleted()
            this.getComment()
          }).catch((error) => {
            this.onResponseError(error)
          }).finally(() => {
            this.$isLoading(false)
          })
        }
      })
    },
    onResetForm () {
      this.comment = ''
      this.validations = {}
      this.$refs.close.click()
      this.$refs.files.value = null
    },
    onSave () {
      const params = new FormData()
      if (this.comment) {
        params.set('comment', this.comment)
      }
      if (this.comment_uuid) {
        params.set('comment_uuid', this.comment_uuid)
      }

      if (this.$refs.files.files) {
        const files = this.$refs.files.files
        Object.keys(files).forEach((key) => {
          params.set(`files[${key}]`, files[key])
        })
      }

      this.validations = {}
      this.isSaveWaiting = true
      this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/comment/update', params)
        .then(({ data }) => {
          if (data.data) {
            this.comment = ''
            this.$store.commit('comment/setRefreshCommentList')
            this.onResponseSuccess()
            this.onResetForm()
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.isSaveWaiting = false
        })
    },
    getComment () {
      this.isLoading = true
      this.$axios.post(this.$base_api + '/api/v4/backend/comment/show', {
        comment_uuid: this.comment_uuid
      }).then(({ data }) => {
        if (data.data) {
          this.comment = data.data.comment
          if (data.data.files) {
            this.files = data.data.files
          } else {
            this.files = []
          }
        } else {
          this.comment = ''
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
ul {
  padding-left: 15px;
}
</style>
